import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API } from '@const'
import * as utils from '@utils'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { EditorState, convertFromRaw } from 'draft-js'
import { Editor } from 'react-draft-wysiwyg'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import Divider from '@material-ui/core/Divider'

const initialState = {
    input: {
        id: null,
        title: '',
        content: null,
    },
    dialogOpen: false,
}

class AnnouncementDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'AnnouncementDialog')
        }
        this.state = initialState
    }

    reset() {
        this.setState({ input: initialState.input })
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    OpenDialog(inputs) {
        this.reset()
        this.queryContent(inputs)
        this.setState({ dialogOpen: true })
    }

    closeDialog() {
        this.setState({ dialogOpen: false })
    }

    confirm() {
        if (this.props.confirmCallback) {
            this.props.confirmCallback()
        }
        this.closeDialog()
    }

    queryContent(inputs) {
        utils.apiRequest(
            'get',
            API.ANNOUNCEMENT_CONTENT,
            {
                id: inputs.id,
            },
            (data) => {
                this.setState({
                    input: {
                        id: inputs.id,
                        title: inputs.title,
                        content: EditorState.createWithContent(convertFromRaw(JSON.parse(data.content))),
                    },
                })
            },
            (_err) => {},
            true
        )
    }

    render() {
        return (
            <Dialog fullWidth maxWidth="md" open={this.state.dialogOpen} onClose={() => this.setState({ dialogOpen: false })}>
                <DialogTitle>{this.state.input.title}</DialogTitle>
                <DialogContent>
                    <Editor
                        toolbarHidden
                        readOnly={true}
                        editorState={this.state.input.content}
                        toolbarClassName={this.props.classes.editorToolbar}
                        wrapperClassName={this.props.classes.editorWrapper}
                        editorClassName={this.props.classes.editorEditor}
                    />
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button variant="contained" onClick={() => this.closeDialog()} color="primary">
                        {this.t('confirm')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const styles = (_theme) => {
    return {
        editorToolbar: {
            border: 'solid 1px',
            margin: '12px 0',
            borderColor: 'rgba(0, 0, 0, 0.3)',
        },
        editorWrapper: {},
        editorEditor: {
            minHeight: '300px',
            padding: '0 14px',
        },
    }
}

AnnouncementDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    confirmCallback: PropTypes.func,
}

export default hoc(styles)(AnnouncementDialog)
